import { render, staticRenderFns } from "./RelatedLettersModal.vue?vue&type=template&id=db14d82e"
import script from "./RelatedLettersModal.vue?vue&type=script&lang=js"
export * from "./RelatedLettersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports